var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{staticClass:"s-uploader-files-button",attrs:{"text":_vm._f("l")('Uploader_SelectFiles')},on:{"click":function($event){return _vm.selectFiles()}}})}
var staticRenderFns = []

export { render, staticRenderFns }